/* Pタグ */
import React from 'react';
import { convertLine } from '../Convert';
var Paragraph = function (_a) {
    var label = _a.label, color = _a.color, bold = _a.bold, css_class = _a.css_class;
    // 太字の設定
    var bold_css = typeof bold !== 'undefined' && bold === true ? 'link-font-bold' : '';
    // 色の規定色
    if (typeof color === 'undefined') {
        color = 'text-dark';
    }
    // CSSクラスの規定値
    if (typeof css_class === 'undefined') {
        css_class = '';
    }
    //改行\nがlabelに存在する場合はエスケープを外す。
    return (React.createElement("div", { className: "paragraph " + color + " " + css_class + " " + bold_css + " bottom-border" }, convertLine(label)));
};
export default Paragraph;
